import { render, staticRenderFns } from "./orderUsp.vue?vue&type=template&id=773fed2e&scoped=true&"
import script from "./orderUsp.vue?vue&type=script&lang=js&"
export * from "./orderUsp.vue?vue&type=script&lang=js&"
import style0 from "./orderUsp.vue?vue&type=style&index=0&id=773fed2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773fed2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773fed2e')) {
      api.createRecord('773fed2e', component.options)
    } else {
      api.reload('773fed2e', component.options)
    }
    module.hot.accept("./orderUsp.vue?vue&type=template&id=773fed2e&scoped=true&", function () {
      api.rerender('773fed2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderDetail/comp/orderUsp.vue"
export default component.exports